import { AppLink } from '@common/components/Link/AppLink';
import { Clip } from '@features/Clip';
import { useSelectClip } from '@features/Clip/hooks/useSelectedClipSelectors';
import { Text } from '@radix-ui/themes';
import { createAssetDetailsPagePath } from '@router';

interface ClipTitleCellProps {
    clip: Clip;
}

export const ClipTitleCell = ({ clip }: ClipTitleCellProps) => {
    const { selectClip } = useSelectClip();
    if (!clip) return;

    const { id, clipName } = clip;

    return (
        <AppLink
            to={createAssetDetailsPagePath(id)}
            onClick={() => selectClip(id)}
        >
            <Text color='gray' weight={'medium'}>
                {clipName}
            </Text>
        </AppLink>
    );
};
